"use client";
import { Box, Container, VStack } from "@chakra-ui/react";
import Header from "./header";
import { Section } from "./tos.constants";
import SectionBlock from "./sectionBlock";

type Props = {
  sections: Section[];
};

const TermsOfServicePage = (props: Props) => {
  const { sections } = props;
  return (
    <Box>
      <Header />
      <Container maxW="3xl" py={12}>
        <VStack gap={10} alignItems="stretch">
          {sections.map((section) => (
            <SectionBlock key={section.id} section={section} />
          ))}
        </VStack>
      </Container>
    </Box>
  );
};

export default TermsOfServicePage;
